
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ClosedDates from '@/components/availability/ClosedDates.vue';
import MenuHours from '@/components/availability/MenuHours.vue';
import PageLoader from '@/components/shared/PageLoader.vue';
import RotationalMenus from '@/components/availability/RotationalMenus.vue';
import SuitesHeader from '@/components/shared/suites/SuitesHeader.vue';
import Tabs from '@/components/shared/Tabs.vue';

@Component<Availabilities>({
	components: {
		ClosedDates,
		MenuHours,
		PageLoader,
		RotationalMenus,
		SuitesHeader,
		Tabs
	}
})
export default class Availabilities extends Vue {
	@Getter('isK12Location', { namespace: 'auth' }) private isK12Location!: boolean;

	$refs!: { rotationalMenus: RotationalMenus; };

	private loading: boolean = false;
	private currentTab: number = 0;

	private get tabs(): Tab[] {
		return [
			{
				key: this.isK12Location ? 'rotational-menus' : 'menu-hours',
				label: this.isK12Location ? this.$t('menu.editor.availability.daily_menus') : this.$t('menu.editor.availability.menu_hours')
			},
			{
				key: 'closed-dates',
				label: this.$t('menu.editor.availability.closed_dates')
			}
		];
	}

	private get initialTab(): string {
		const hash = window.location.hash.replace('#', '');
		const tab = this.tabs.find(tab => tab.key === hash && !tab.hidden);
		return tab ? tab.key : this.tabs[0].key;
	}

	private created(): void {
		this.currentTab = this.tabs.findIndex(tab => tab.key === this.initialTab);
	}

	/**
	 * Force the tabs to unmount/remount so children re-fetch with updated data
	 * after hours were copied to other menus. The .spinner-delayed CSS on
	 * PageLoader ensures the spinner only paints if the remount actually
	 * takes more than 200ms.
	 *
	 * @return {Promise<void>}
	 */
	private async showLoadingSpinner(): Promise<void> {
		this.loading = true;
		await this.$nextTick();
		this.loading = false;
	}

	private onTabChange(tab: Tab): void {
		const tabIndex = this.tabs.findIndex(t => t.key === tab.key);
		this.currentTab = tabIndex !== -1 ? tabIndex : 0;
	}

	private async handleClosedDateChange(): Promise<void> {
		if (this.isK12Location && this.$refs.rotationalMenus) {
			await this.$refs.rotationalMenus.fetchAndSetRotationalMenus();
		}
	}
}
